import { createSvgIcon } from "@mui/material";

export const ChevronIcon = createSvgIcon(
  <svg viewBox="-2 -2 12 12" fill="none">
    <path
      fill="currentColor"
      d="M 4 6.2854 L 0 2.8568 L 0.9791 1.7146 L 4 4.3039 L 7.0209 1.7146 L 8 2.8568 L 4 6.2854 Z"
    />
  </svg>,
  "ChevronIcon",
);
